import { jsx } from 'react/jsx-runtime';
import { makeStyles } from '@material-ui/core/styles';
import { columnFactories } from './columns.esm.js';
import { systemEntityColumns, componentEntityColumns } from './presets.esm.js';
import { Table } from '@backstage/core-components';

const useStyles = makeStyles((theme) => ({
  empty: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "center"
  }
}));
const EntityTable = (props) => {
  const {
    entities,
    title,
    emptyContent,
    variant = "gridItem",
    columns,
    tableOptions = {}
  } = props;
  const classes = useStyles();
  const tableStyle = {
    minWidth: "0",
    width: "100%"
  };
  if (variant === "gridItem") {
    tableStyle.height = "calc(100% - 10px)";
  }
  return /* @__PURE__ */ jsx(
    Table,
    {
      columns,
      title,
      style: tableStyle,
      emptyContent: emptyContent && /* @__PURE__ */ jsx("div", { className: classes.empty, children: emptyContent }),
      options: {
        // TODO: Toolbar padding if off compared to other cards, should be: padding: 16px 24px;
        search: false,
        paging: false,
        actionsColumnIndex: -1,
        padding: "dense",
        draggable: false,
        ...tableOptions
      },
      data: entities
    }
  );
};
EntityTable.columns = columnFactories;
EntityTable.systemEntityColumns = systemEntityColumns;
EntityTable.componentEntityColumns = componentEntityColumns;

export { EntityTable };
//# sourceMappingURL=EntityTable.esm.js.map
